import React, { Component } from 'react';
import { connect } from 'react-redux';
import merge from 'lodash/merge';
import PropTypes from 'prop-types';
import isEmpty from 'lodash/isEmpty';
import { Elements, StripeProvider } from 'react-stripe-elements';
import PaymentForm from '../../components/PaymentForm';
import { sendPaymentToken } from '../../store/actions/Payment';
import { getProject } from '../../store/actions/ProjectView';
import { selectProject } from '../../store/actions/Dashboard';
import { routesAction } from '../../shared/helpers';

const { REACT_APP_STRIPE_KEY } = process.env;

class Payment extends Component {
  constructor(props) {
    super(props);
    this.sendPayment = this.sendPayment.bind(this);
  }

  componentDidMount() {
    this.loadProjectInfo();
  }

  loadProjectInfo() {
    const {
      project,
      match: {
        params: { project_id: projectId },
      },
      dispatchGetProject,
    } = this.props;
    if (isEmpty(project)) {
      dispatchGetProject(projectId);
    }
  }

  sendPayment(formData, setSubmitting) {
    const {
      dispatchSendPayment,
      match: {
        params: { project_id: projectId },
      },
      history: { push },
    } = this.props;

    dispatchSendPayment({ ...formData, projectId }).then(() => {
      setSubmitting(false);
      push(routesAction.project(projectId));
    });
  }

  render() {
    const { currentOnboardingSteps: project, user } = this.props;

    const keyQuestions = [
      'type',
      'basic_requirements',
      'duration',
      'series',
      'format',
    ];

    const resumeList = keyQuestions.map(key => ({
      [key]: this.getStepValue(project, 'basic_information', key),
    }));

    const { finalPrice } = project;

    return (
      <StripeProvider apiKey={REACT_APP_STRIPE_KEY}>
        <Elements>
          <PaymentForm
            onSubmit={this.sendPayment}
            projectResume={{ ...merge(...resumeList), finalPrice }}
            user={user}
          />
        </Elements>
      </StripeProvider>
    );
  }

  getStepValue = (project, overviewStep, key) => {
    const step = project[overviewStep].onboardingSteps.find(s => s.key === key);

    return step.cards
      .filter(card => step.selectedValue.includes(card.value))
      .map(card => card.label)
      .join(', ');
  };
}

const mapStateToProps = state => {
  const currentOnboardingSteps = state.onboarding;
  const { user } = state.authentication;
  return {
    currentOnboardingSteps,
    user,
  };
};

const mapDispatchToProps = dispatch => ({
  dispatchGetProject: id =>
    dispatch(getProject(id)).then(({ payload: { project } }) => {
      dispatch(selectProject(project.id, project));
    }),
  dispatchSendPayment: params => dispatch(sendPaymentToken(params)),
});

Payment.propTypes = {
  currentOnboardingSteps: PropTypes.object,
  dispatchSendPayment: PropTypes.func,
  dispatchGetProject: PropTypes.func,
  history: PropTypes.object,
  project: PropTypes.object,
  match: PropTypes.object,
  user: PropTypes.object,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Payment);



// WEBPACK FOOTER //
// ./src/containers/Payment/Payment.js